import { Navigate } from "react-router-dom";

import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  Attendance,
  AttendanceTracking,
  DailyAttendance,
  ImportAddOvertime,
  ImportAttendance,
  ImportUpdateOvertime,
  SummaryAttendance,
} from "./pages";

const attendanceRoutes = [
  {
    path: "/presence/attendance",
    element: (
      <ProtectedRoute name="presence">
        <Attendance />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="attendance"
        defaultTitle="attendance.attendance_data"
      />
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/presence/attendance/daily" replace />,
      },
      {
        path: "/presence/attendance/daily",
        element: <DailyAttendance />,
        breadcrumb: null,
      },
      {
        path: "/presence/attendance/summary",
        element: <SummaryAttendance />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/presence/attendance/daily/import",
    element: (
      <ProtectedRoute name="presence">
        <ImportAttendance />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="attendance.import_attendance" />
    ),
  },
  {
    path: "/presence/attendance/daily/import-add-overtime",
    element: (
      <ProtectedRoute name="presence_overtime_add">
        <ImportAddOvertime />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="attendance.import_add_overtime" />
    ),
  },
  {
    path: "/presence/attendance/daily/import-update-overtime",
    element: (
      <ProtectedRoute name="presence_overtime_edit">
        <ImportUpdateOvertime />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="attendance.import_update_overtime" />
    ),
  },
  {
    path: "/presence/attendance/daily/tracking/:id",
    element: (
      <ProtectedRoute name="location_tracking">
        <AttendanceTracking />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="location_tracking"
        defaultTitle="tracking.title"
      />
    ),
  },
];

export default attendanceRoutes;
